import PropTypes from 'prop-types';

export const PLATFORM_ACCOUNT = {
    follower_count: PropTypes.number.isRequired,
    following_count: PropTypes.number.isRequired,
    platform_handle: PropTypes.string.isRequired,
    platform_id: PropTypes.string,
    post_count: PropTypes.number
};

export const SOCIAL_ENGAGEMENTS = {
    dislikes: PropTypes.number,
    engagements: PropTypes.number.isRequired,
    favorites: PropTypes.number,
    likes: PropTypes.number.isRequired,
    replies: PropTypes.number.isRequired,
    shares: PropTypes.number,
    views: PropTypes.number
};

export const CONTENT_DISTRIBUTION_METADATA = {
    caption: PropTypes.string,
    content_type: PropTypes.string,
    created_at: PropTypes.string,
    distribution_platform: PropTypes.string,
    distribution_platform_media_id: PropTypes.string,
    distribution_latform_media_url: PropTypes.string,
    distribution_platform_post_id: PropTypes.string,
    distribution_platform_post_url: PropTypes.string,
    extra: PropTypes.any,
    replies: PropTypes.array,
    snapshots: PropTypes.shape({
        performance: PropTypes.array,
        platform_account: PropTypes.shape(PLATFORM_ACCOUNT).isRequired,
        social_engagements: PropTypes.shape(SOCIAL_ENGAGEMENTS).isRequired
    }).isRequired
};

export const POST = {
    campaign_id: PropTypes.number.isRequired,
    content_distribution_metadata: PropTypes.shape(CONTENT_DISTRIBUTION_METADATA),
    content_extension: PropTypes.string.isRequired,
    content_metadata_id: PropTypes.number.isRequired,
    content_thumbnail_extension: PropTypes.string.isRequired,
    content_type: PropTypes.string.isRequired,
    content_url: PropTypes.string.isRequired,
    engagements: PropTypes.number.isRequired,
    engagements_weighted: PropTypes.number,
    invite_flight_id: PropTypes.number,
    is_featured: PropTypes.number,
    media_id: PropTypes.string,
    post_id: PropTypes.number.isRequired,
    post_user_score: PropTypes.number,
    social_engagements_weighted: PropTypes.string,
    tags: PropTypes.array.isRequired,
    thumbnail_url: PropTypes.string.isRequired,
    platform_type: PropTypes.string
};



// WEBPACK FOOTER //
// ./common/proptypes/post_props.js